export default __webpack_public_path__ + "media/images/badge-level2-size16-2e4bd891ace5f18820a5a3372e0834e8.png";